import type { User } from "@entities/user";
import { getConnection } from "@app/sdk";
import api from "@api";

export const checkSession = async (): Promise<User | null> => {
  const response = await api.functional.auth.me.getCurrentUser(getConnection());
  return (response.user as unknown as User) ?? {};
};
